import store from '../../core/store';

export const updateAttachment = (attachment_id, formData) => {
  return store.dispatch({
    action: 'attachments/UPDATE_ATTACHMENT',
    method: 'PUT',
    endpoint: '/attachments/' + attachment_id,
    data: formData,
  });
};

export const uploadAttachmentVersion = (attachment_id, formData) => {
  return store.dispatch({
    action: 'attachments/UPLOAD_ATTACHMENT_VERSION',
    method: 'POST',
    preloaded: false,
    endpoint: '/attachments/' + attachment_id + '/versions',
    data: formData,
  });
};

export const listAttachmentVersions = (attachment_id) => {
  return store.dispatch({
    action: 'attachments/LIST_ATTACHMENT_VERSIONS',
    method: 'GET',
    endpoint: '/attachments/' + attachment_id + '/versions',
  });
};

export const archiveAttachment = (attachment_id) => {
  return store.dispatch({
    action: 'attachments/ARCHIVE_ATTACHMENT',
    method: 'PUT',
    endpoint: '/attachments/' + attachment_id + '/archive',
  });
};

export const unarchiveAttachment = (attachment_id) => {
  return store.dispatch({
    action: 'attachments/UNARCHIVE_ATTACHMENT',
    method: 'PUT',
    endpoint: '/attachments/' + attachment_id + '/unarchive',
  });
};

export const deleteAttachmentCurrentVersion = (attachment_id) => {
  return store.dispatch({
    action: 'attachments/DELETE_ATTACHMENT_CURRENT_VERSION',
    method: 'DELETE',
    endpoint: '/attachments/' + attachment_id + '/current_version',
  });
};
